export default "__VITE_ASSET__6ca3b303__"